import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dependentField", "triggerField"]

  connect() {
    if (!this.hasTriggerFieldTarget) return

    this.toggleField()
  }

  toggleField() {
    const showValues = ['mandatory', 'optional']
    const triggerValue = this.triggerFieldTarget?.value

    this.dependentFieldTargets.forEach(field => {
      field.classList.toggle('hidden', !showValues.includes(triggerValue))
    })
  }
}
